<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>实名信息审核</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="goBack">返回</el-button>
                </el-col>
            </el-row>
        </div>
    
        <el-form :model="userInfo" class="demo-form-inline" label-width="150px">
            <el-form-item label="昵称">
                <span>{{userDetail.nickName}}</span>
            </el-form-item>
            <el-form-item label="手机号">
                <span>{{userDetail.username}}</span>
            </el-form-item>
            <el-form-item label="性别">
                
                <div>
                    <span v-if="userDetail.gender === '1'">男</span>
                    <span v-if="userDetail.gender === '2'">女</span>
                    <span v-if="userDetail.gender === '0' || userDetail.gender === null">暂无</span>
                </div>
            </el-form-item>
            <el-form-item label="申请时间" v-if="userInfo && userInfo.zmUpdated">
                <span>{{ new Date(userInfo.zmUpdated).getFullYear()+'-'+(new Date(userInfo.zmUpdated).getMonth()+1)+'-'+new Date(userInfo.zmUpdated).getDate()+' '+new Date(userInfo.zmUpdated).getHours()+':'+new Date(userInfo.zmUpdated).getMinutes()+':'+new Date(userInfo.zmUpdated).getSeconds()}} </span>
            </el-form-item>
            <el-form-item label="真实姓名" style="margin-right: 20px">
                <span>{{userInfo.realName || '未填写'}}</span>
            </el-form-item>
            <el-form-item label="身份证号" style="margin-right: 20px">
                <span>{{userInfo.idCard}}</span>
            </el-form-item>
            <el-form-item label="工作单位／学校" style="margin-right: 20px">
                <span>{{userInfo.institution}}</span>
            </el-form-item>
            <!-- <el-form-item label="省市区" style="margin-right: 20px">
                <div>
                    <span v-if="addressInfo && addressInfo.province">{{addressInfo.province}}省{{addressInfo.city}}{{addressInfo.district}}</span>
                    <span v-else>暂无</span>
                </div>
            </el-form-item> -->
            <el-form-item label="现居住地址" style="margin-right: 20px">
                <!-- <span>{{addressInfo.fullAddress || '暂无'}}</span> -->
                <span>{{userInfo.address || '暂无'}}</span>
            </el-form-item>
            <el-form-item label="身份证照片" v-if="userInfo.pictures">
                <span v-if="userInfo.pictures[0].length < 4">暂未上传</span>
                <img v-for="(item,index) in userInfo.pictures" v-if="index != 3" :key="index" :src="item" alt="" style="margin-right: 15px;width: 200px;">
            </el-form-item>
            <el-form-item label="学生证照片" v-if="userInfo.pictures && userInfo.pictures[3].length">
                <img :src="userInfo.pictures[3]" alt="" style="margin-right: 15px;width: 300px;">
            </el-form-item>
            <el-form-item label-width="150px">
                <el-button type="primary" @click="onSubmit">审核通过</el-button>
                <el-button @click="handleNo">审核不通过</el-button>
            </el-form-item>
        </el-form>
    
        <el-dialog title="提示" :visible.sync="dialogVisible" size="tiny">
            <span>审核通过，请输入免押金额度（单位：分）</span>
            <el-input v-model="line"></el-input>
            <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="sureEnter">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="提示" :visible.sync="passVisible" size="tiny">
            <span>审核不通过，请输入原因</span>
            <el-input v-model="remark"></el-input>
            <span slot="footer" class="dialog-footer">
            <el-button @click="passVisible = false">取 消</el-button>
            <el-button type="primary" @click="surePass">确 定</el-button>
          </span>
        </el-dialog>
    
    
    </div>
</template>

<script>
    import {
        getIdentificationId,
        getUsersDetail,
        getDefaultAddress,
        putUserManage
    } from '../../api/version'
    
    export default {
        data() {
            return {
                userInfo: {},
                addressInfo: {},
                userDetail: {},
                dialogVisible: false,
                passVisible: false,
                line: '',
                remark: ''
            }
        },
    
        created() {
            getIdentificationId(sessionStorage.userId, this.$route.params.id).then(res => {
                console.log(res.data, 'ffd')
                this.userInfo = res.data
                res.data.pictures.forEach((item, index) => {
                    console.log(item)
                    if (item.length > 4) {
                        this.userInfo.pictures[index] = `https://img.shareplay.cc/${item}`
                    }
                })
                console.log(this.userInfo.pictures, 'ff')
            })
    
            getUsersDetail(sessionStorage.userId, this.$route.params.id).then(res => {
                this.userDetail = res.data
            })
    
            getDefaultAddress(sessionStorage.userId, this.$route.params.id).then(res => {
                console.log(res.data)
                this.addressInfo = res.data
            })
        },
    
        methods: {
            goBack() {
                this.$router.push('/identified')
            },
            handleNo() {
                this.passVisible = true
            },
            surePass() {
                putUserManage(sessionStorage.userId, this.$route.params.id, {
                    id: this.$route.params.id,
                    remark: this.remark,
                    line: 0
                }).then(res => {
                    if (res.data) {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.$router.push('/identified')
                    }
                }, err => {
                    this.$message.error('提交失败')
                })
            },
            sureEnter() {
                putUserManage(sessionStorage.userId, this.$route.params.id, {
                    id: this.$route.params.id,
                    line: this.line*1
                }).then(res => {
                    if (res.data) {
                        this.$message({
                            message: '审核通过',
                            type: 'success'
                        });
                        this.$router.push('/identified')
                    }
                }, err => {
                    this.$message.error('审核失败')
                })
            },
            onSubmit() {
                this.dialogVisible = true
    
            }
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// ChangeIdentified.vue?786c4166